import { Dish } from '@api/Dishes/Dish';
import DishServ from '@api/Dishes/DishServ';

class DishesService {
    saveDish = (dish: Dish): Promise<Dish> => {
        return new Promise(async (resolve, reject) => {
            try {
                const data = await DishServ.saveDish(dish);
                resolve(data);
            } catch (error) {
                reject('Error saving dish: ' + error);
            }
        });
    };
    getDishes = (): Promise<Dish[]> => {
        return new Promise(async (resolve, reject) => {
            try {
                const data = await DishServ.getDishes();
                resolve(data);
            } catch (error) {
                reject('Error getting dishes: ' + error);
            }
        });
    };
    getDish = (dishId: string): Promise<Dish> => {
        return new Promise(async (resolve, reject) => {
            try {
                const dish = await DishServ.getDish(dishId);
                resolve(dish);
            } catch (error) {
                reject('Error getting dish: ' + error);
            }
        });
    };
    toggleStatus = (dishId: string): Promise<void> => {
        return new Promise(async (resolve, reject) => {
            try {
                await DishServ.toggleStatus(dishId);
                resolve();
            } catch (error) {
                reject('Error updating dish status: ' + error);
            }
        });
    };
    deleteDish = (dishId: string): Promise<void> => {
        return new Promise(async (resolve, reject) => {
            try {
                await DishServ.deleteDish(dishId);
                resolve();
            } catch (error) {
                reject('Error deleting dish: ' + error);
            }
        });
    };
}
export default DishesService;
